import { connect } from 'react-redux'
import styled from 'astroturf/react'

import RadioButtonField from 'components/form/radio_button'
import TextField from 'components/form/text'
import PhoneField from 'components/form/phone'
import Label from 'components/location/multiple/label'
import { onLocationChange, onPhoneNumberChange } from 'actions/scheduling'
import { dismissValidationError } from 'actions/errors'
import {
  selectedLocationConfigurationSelector,
  inviteeLocationErrorsSelector,
  inviteePhoneNumberErrorsSelector,
  inviteeLocationChoiceErrorsSelector,
  locationPhoneNumberSelector,
  selectedLocationSelector,
  countryCodeSelector
} from 'selectors'
import { useI18n } from 'locales'
import _LocationInput from "location_choice-LocationInput.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/location/multiple/location_choice.js?styleId=LocationInput";
import _LocationChoice from "LocationChoice.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/location/multiple/location_choice.js?styleId=LocationChoice";


const LocationInput = /*#__PURE__*/styled('div', null, {
  displayName: "LocationInput",
  styles: _LocationInput
})

const LocationChoice = /*#__PURE__*/styled('div', null, {
  displayName: "LocationChoice",
  styles: _LocationChoice
})

const LocationChoiceComponent = ({
  locationConfiguration,
  onChange,
  isSelected,
  phoneNumber,
  location,
  countryCode,
  handleLocationChange,
  handlePhoneNumberChange,
  locationErrors,
  phoneNumberErrors,
  radioHasError,
  as
}) => {
  const { i18n } = useI18n()
  const dynamicInfo = ({
    ask_invitee: (
      <LocationInput>
        <TextField
          name="location"
          aria-label={i18n.t('booking.location.ask_invitee.input_label')}
          onChange={handleLocationChange}
          placeholder={i18n.t('booking.location.ask_invitee.placeholder')}
          value={location}
          error={locationErrors?.[0]}
        />
      </LocationInput>
    ),
    outbound_call: (
      <LocationInput>
        <PhoneField
          aria-label={i18n.t('booking.location.outbound_call.input_label')}
          name="phone_number"
          number={phoneNumber}
          error={phoneNumberErrors?.[0]}
          onChange={handlePhoneNumberChange}
          countryCode={countryCode}
        />
      </LocationInput>
    )
  }[locationConfiguration.kind])

  return (
    <LocationChoice data-component="location-choice">
      <RadioButtonField
        as={as}
        checked={isSelected}
        name="location"
        value={locationConfiguration.kind}
        label={(
          <Label
            locationConfiguration={locationConfiguration}
            isSelected={isSelected}
          />
        )}
        hasError={radioHasError}
        onChange={onChange}
      />
      {isSelected && dynamicInfo}
    </LocationChoice>
  )
}

const mapStateToProps = (state, ownProps) => {
  const locationErrors = inviteeLocationErrorsSelector(state)
  const phoneNumberErrors = inviteePhoneNumberErrorsSelector(state)
  const locationChoiceErrors = inviteeLocationChoiceErrorsSelector(state)
  const countryCode = countryCodeSelector(state)
  const config = selectedLocationConfigurationSelector(state)

  return {
    locationErrors,
    phoneNumberErrors,
    locationChoiceErrors,
    countryCode,
    isSelected: config.id === ownProps.locationConfiguration.id,
    phoneNumber: locationPhoneNumberSelector(state),
    location: selectedLocationSelector(state),
    radioHasError: (ownProps.locationConfiguration.kind === 'ask_invitee' && !!locationErrors.length)
        || (ownProps.locationConfiguration.kind === 'outbound_call' && !!phoneNumberErrors.length)
        || !!locationChoiceErrors.length
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleLocationChange: (event) => {
    dispatch(onLocationChange(event.target.value))
    dispatch(dismissValidationError('event', 'location'))
  },
  handlePhoneNumberChange: (event) => {
    dispatch(onPhoneNumberChange(event))
    dispatch(dismissValidationError('event', 'phone_number'))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationChoiceComponent)
